import React from "react";
import PropTypes from "prop-types";
import SocialButton from "components/v3/social-button/SocialButton";
import styles from "./styles.module.scss";
import { SOCIAL_MEDIA } from "common/constants/v2/Constants";

const SocialButtons = ({ onClick }) => {
    return (
        <div className={ styles.socialButtons }>
            <SocialButton onClick={ () => onClick(SOCIAL_MEDIA.FACEBOOK) } site={ SOCIAL_MEDIA.FACEBOOK } linkSite={ true } />
            <SocialButton onClick={ () => onClick(SOCIAL_MEDIA.TWITTER) } site={ SOCIAL_MEDIA.TWITTER } linkSite={ true } />
            <SocialButton onClick={ () => onClick(SOCIAL_MEDIA.APPLE) } site={ SOCIAL_MEDIA.APPLE } linkSite={ true } />
        </div>
    );
};

SocialButtons.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default SocialButtons;
